import { TagColor, Tag, TagVariant } from '@shipengine/giger';
import { useTranslation } from '@packlink/translation-provider';
import { getServiceTagStyle } from './ServiceTagStyles.js';
import { ServiceTagType } from '@packlink/packlink-sdk';
import { jsx } from '@emotion/react/jsx-runtime';

const SERVICES_TAG_OPTIONS = {
  [ServiceTagType.NEW_SERVICE]: {
    color: TagColor === null || TagColor === void 0 ? void 0 : TagColor.INFO,
    translationKey: 'service-card.tagged-service.new-service'
  },
  [ServiceTagType.NEW_PRICE]: {
    color: TagColor === null || TagColor === void 0 ? void 0 : TagColor.INFO,
    translationKey: 'service-card.tagged-service.new-price'
  },
  [ServiceTagType.PROMOTION]: {
    color: TagColor === null || TagColor === void 0 ? void 0 : TagColor.INFO,
    translationKey: 'service-card.tagged-service.promotion'
  },
  [ServiceTagType.RECOMMENDED]: {
    color: TagColor === null || TagColor === void 0 ? void 0 : TagColor.INFO,
    translationKey: 'service-card.tagged-service.recommended'
  },
  [ServiceTagType.ECO_FRIENDLY]: {
    color: TagColor === null || TagColor === void 0 ? void 0 : TagColor.SUCCESS,
    translationKey: 'service-card.tagged-service.eco-friendly'
  },
  [ServiceTagType.POPULAR]: {
    color: TagColor === null || TagColor === void 0 ? void 0 : TagColor.INFO,
    translationKey: 'service-card.tagged-service.popular'
  },
  [ServiceTagType.EXCLUSIVE_FOR_PLUS]: {
    color: TagColor === null || TagColor === void 0 ? void 0 : TagColor.INFO,
    translationKey: 'service-card.tagged-service.exclusive-for-plus'
  }
};
const ServiceTag = _ref => {
  let {
    color,
    translationKey
  } = _ref;
  const {
    t
  } = useTranslation();
  return jsx(Tag, {
    variant: TagVariant.FILLED,
    color: color,
    css: getServiceTagStyle,
    uppercase: false,
    children: t(translationKey)
  });
};

export { SERVICES_TAG_OPTIONS, ServiceTag };
//# sourceMappingURL=ServiceTag.js.map
